import React from 'react';
import { Icon } from 'semantic-ui-react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { connect } from 'react-redux';
import NewEntryModal from './new_entry_modal'
import AppComponent from './app_component'
import TemplateControlsRenderer from './controls_component/template_controls_renderer';
import CreateControlModal from './controls_component/create_control_modal';

import LanguageService from '../services/languageService';

import { initNewWorkPhaseEntry, initNewActivityEntry, initNewHazardEntry, initNewUnwantedEventEntry } from '../helpers/risk_helpers';
import { getText } from '../helpers';

class AdminTable extends AppComponent {
  constructor(props){
    super(props);

    const { instanceConfig, language } = props;

    const { translations, name: languageName } = language;

    const { work_phase_or_ambient_exposure, activity, hazard, unwanted_event } = translations;

    const { features } = instanceConfig;
    const isDefaultTemplateControlEnabled = features && features.default_template_control

    this.templateColumns = [
      {
        dataField: 'work_phase_or_ambient_exposure',
        text: work_phase_or_ambient_exposure, //Formerly 'Activity', renamed as requested by the client
        formatter: this.cellFormatter,
        headerStyle: {
          width: '200px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        align: 'center',
        headerClasses: 'column-color-workphase',
        classes: 'column-color-workphase work-phase-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'activity',
        text: activity, //Formerly 'Step in Process', renamed as requested by the client
        formatter: this.cellFormatter,
        headerStyle: {
          width: '180px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        align: 'center',
        headerClasses: 'column-color-activity',
        classes: 'column-color-activity activity-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'hazard',
        text: hazard,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        align: 'center',
        headerClasses: 'column-color-hazard-event',
        classes: 'column-color-hazard-event hazard-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'unwanted_event',
        text: unwanted_event,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '180px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        align: 'center',
        headerClasses: 'column-color-hazard-event',
        classes: 'column-color-hazard-event unwanted-event-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'existing_preventative',
        text: getText("Default Template Preventative Controls"),
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, 'existing-preventative'),
        headerTitle: true,
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        editable: false,
        hidden: !isDefaultTemplateControlEnabled,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      },
      {
        dataField: 'existing_recovery',
        text: getText("Default Template Recovery Controls"),
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, "existing-recovery"),
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false,
        hidden: !isDefaultTemplateControlEnabled,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      }
    ]

    this.state = {
      newEntry: {},
      showNewEntryForm: false,
      translations,
      contextMenu: {
        new: {
          innerHTML: 'New',
          style: { float: 'left', cursor: 'pointer' }
        }
      },
      languageName,
      tagOptions: [],
      createControlShown: false
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.getTranslationsSuccess){
      this.setState({
        translations: nextProps.language.translations,
        languageName: nextProps.language.name
      }, ()=> {
        this.templateColumns[0].text = nextProps.language.translations.work_phase_or_ambient_exposure
        this.templateColumns[1].text = nextProps.language.translations.activity
        this.templateColumns[2].text = nextProps.language.translations.hazard
        this.templateColumns[3].text = nextProps.language.translations.unwanted_event
        this.forceUpdate()
      })
    }
  }

  cellFormatter = (cell, row, rowIndex) => {
    return (
     <span className='cell-style' cell={ cell } row={ rowIndex }>
      { cell }
     </span>
    )
  }

  headerFormatter = (column, filterElement, sortBy) => {
    var text;

    if(column.text.indexOf("\n") !== -1) {
      text = (<p><i>{column.text.split("\n")[0]}</i><br/>{column.text.split("\n")[1]}</p>)
    }
    else {
      text = column.text
    }
    return (
      <div style={ { display: 'flex', flexDirection: 'column' } }>
        { text }
        { filterElement }
      </div>
    );
  }

  sortIcon = (order) => {
     if(order.toUpperCase() === 'ASC') {
       return <div className='sort-icon-div'><Icon name='angle up'/>ASC</div>
     }
     else {
       return <div className='sort-icon-div'><Icon name='angle down'/>DESC</div>
     }
  }

  controlsCellFormatter = (cell, row, planId, controlType) => {
    const { work_phase_or_ambient_exposure: workPhase, activity, hazard, unwanted_event: unwantedEvent } = row;
    const { refreshRowsWithCreatedControls, showRemoveFromPlansBackgroundJobInfo } = this.props;
    return (
      <TemplateControlsRenderer
        value={cell || []}
        planId={planId}
        riskId={row.id}
        controlType={controlType}
        setTagOptions={this.setTagOptions}
        translations={this.state.translations}
        TagOptions={this.controlTagOptions}
        workPhase={workPhase}
        activity={activity}
        hazard={hazard}
        unwantedEvent={unwantedEvent}
        refreshRowsWithCreatedControls={refreshRowsWithCreatedControls}
        showRemoveFromPlansBackgroundJobInfo={showRemoveFromPlansBackgroundJobInfo}
        isTemplate={true}
        />
    )
  }

  onSubmitEntry = (risk) => {
    this.props.createRisk(risk)
    this.toggleNewEntryForm(false)
  }

  onContextMenu = (event, cell, rowIndex) => {
    this.closeContextMenu()

    var { newEntry, contextMenu, translations } = this.state;
    const { work_phase_or_ambient_exposure, activity, hazard, unwanted_event, new: new_label } = translations;
    const { risks, instanceConfig } = this.props;
    const { enable_workphase_addition: workphaseAdditionEnabled } = instanceConfig;
    const selectedRisk = {...risks[rowIndex]};

    const isWorkPhaseCell = event.target.className.includes('work-phase-cell');
    const isActivityCell = event.target.className.includes('activity-cell');
    const isHazardCell = event.target.className.includes('hazard-cell');
    const isUnwantedEventCell = event.target.className.includes('unwanted-event-cell');
    if(isWorkPhaseCell && workphaseAdditionEnabled) {
      newEntry = initNewWorkPhaseEntry({...selectedRisk, hidden: null});
      contextMenu.new.innerHTML = `${new_label} ${ work_phase_or_ambient_exposure }`
    }
    else if(isActivityCell) {
      newEntry = initNewActivityEntry({...selectedRisk, hidden: null});
      contextMenu.new.innerHTML = `${new_label} ${ activity }`
    }
    else if(isHazardCell) {
      newEntry = initNewHazardEntry({...selectedRisk, hidden: null});
      contextMenu.new.innerHTML = `${new_label} ${ hazard }`
    }
    else if(isUnwantedEventCell) {
      newEntry = initNewUnwantedEventEntry({...selectedRisk, hidden: null});
      contextMenu.new.innerHTML = `${new_label} ${ unwanted_event }`
    }

    this.setState({ newEntry, contextMenu })

    event.preventDefault();

    let menuElement = document.getElementById("admin_table_contextmenu");
    this.autoPositionElement(event, menuElement)
  }

  closeContextMenu = () => {
    let menu = document.getElementById("admin_table_contextmenu");
    menu.style.cssText = 'visibility: hidden;';
  }

  setTagOptions = (tag) => {
    var found = this.state.tagOptions.some((el) => {
      return el.value === tag.value;
    });
    if (!found) {
      this.state.tagOptions.push(tag);
    }

    this.setState({
      tagOptions: this.state.tagOptions
    })
  }

  showCreateControl = () => {
    this.setState({
      createControlShown: true
    })
  }

  hideCreateControl = () => {
    this.setState({
      createControlShown: false
    })
  }

  createLibraryControls = (libraryControls) => {
    const { controls } = this.state;
    this.hasBeenFocused = false
    this.setState({
      controlIndex: controls.length, createControlShown: false
    })

    const libraryControlList = libraryControls.map((libraryControl) => ({
      control_type: this.props.controlType,
      name: libraryControl.title,
      library_control_id: libraryControl.id
    }))

    const control_data = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      controls: libraryControlList
    }
    this.props.createControls(control_data);
  }

  createCustomControls = (customControls) => {
    const { controls } = this.state;
    this.hasBeenFocused = false
    this.setState({
      controlIndex: controls.length, createControlShown: false
    })

    const customControlList = customControls.map((customControl) => ({
      control_type: this.props.controlType,
      name: customControl.name,
      library_control_id: null
    }))

    const control_data = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      controls: customControlList
    }
    this.props.createControls(control_data);
  }

  render() {
    const rowEvents = {
      onContextMenu: (e) => {
        var cell = null
        var rowIndex = null
        var element = e.target
        if(element.getAttribute("row") === null) {
          element = element.getElementsByTagName("span")
          cell = element[0] && element[0].attributes.cell.value
          rowIndex = element[0] && element[0].attributes.row.value
        }
        else {
          cell = element.getAttribute("cell")
          rowIndex = element.getAttribute("row")
        }
        if (!cell || !rowIndex) return;

        this.onContextMenu(e, cell, parseInt(rowIndex, 10))
      },
      onMouseDown: (e) => {
        this.closeContextMenu()
      }
    }

    if (this.props.risks.length <= 15){
      this.templateColumns[0].classes = 'column-color-workphase custom-height work-phase-cell'
    }
    else {
      this.templateColumns[0].classes = 'column-color-workphase work-phase-cell'
    }

    const { translations, contextMenu, newEntry, showNewEntryForm, createControlShown } = this.state

    const { shouldShowScrollInstruction, shouldShowLoadingMessage, loadingMessage } = this.props;

    return (
      <div className="template-table">
        <BootstrapTable
          tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
          keyField="id"
          data={ this.props.risks }
          columns={ this.templateColumns }
          striped
          hover
          condensed
          noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>{translations.no_risk_selected}</span>}
          defaultChecked={ false }
          selectRow={ this.props.selectRow }
          rowEvents={ rowEvents }
        />
        <span id="admin_table_contextmenu">
          <span style={contextMenu.new.style} onClick={ () => this.toggleNewEntryForm(true) }>{contextMenu.new.innerHTML}</span>
          {
            showNewEntryForm && 
            <NewEntryModal
              headerText={ contextMenu.new.innerHTML }
              shown={ showNewEntryForm }
              risk={ newEntry }
              onSubmit={ this.onSubmitEntry }
              onClose={ () => this.toggleNewEntryForm(false) }
              translations={translations}
              isTemplate
            />
          }
        </span>
        {
          createControlShown && 
          <CreateControlModal
            createLibraryControls={this.createLibraryControls}
            createCustomControls={this.createCustomControls}
            hideCreateControl={this.hideCreateControl}
          />
        }
        {
          shouldShowScrollInstruction &&
          <div className="scroll-instruction">
            <i className="icon arrow down"></i>
            <span>{getText("Scroll down to show more rows")}</span>
          </div>
        }
        {
          shouldShowLoadingMessage &&
          <div id="loading-message">
            <i className="loading circle notched icon plan-loading"></i>
            <span>{loadingMessage}</span>
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    updateSuccess: state.risk.updateSuccess,
    pending: state.risk.pending,
    language: state.language.language,
    languages: state.language.languages,
    getTranslationsSuccess: state.language.getSuccess,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTable);



// WEBPACK FOOTER //
// ./src/components/admin_table.js